
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/mobile-top-up-rewards",
      function () {
        return require("private-next-pages/mobiworkx/mobile-top-up-rewards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/mobile-top-up-rewards"])
      });
    }
  